const CartTypes = {
    SET_INTERNAL_EXTERNAL: 'SET_INTERNAL_EXTERNAL',
    SET_INTSTALLATION: 'SET_INTSTALLATION',
    SET_PRICE: "SET_PRICE",
    CHANGE_PORTAL: 'CHANGE_PORTAL'
};

export default CartTypes;